import { Field, WrappedFieldArrayProps } from "redux-form";
import { Button } from "rsuite";
import LegacyTrashIcon from "@rsuite/icons/legacy/Trash";
import InputWithLabel from "shared/components/redux-form/InputWithLabel";
import TextArea from "shared/components/redux-form/TextArea";
import clsx from "clsx";

export default function StoreDescription({
  fields,
  title,
  buttonName,
}: WrappedFieldArrayProps<any> & {
  title?: string;
  buttonName: string;
}) {
  return (
    <div className="spacing">
      <div className={clsx("custom-field-header")}>
        <div className="fragment-title">
          <div className="section-title">{title}</div>
        </div>

        <Button appearance="primary" onClick={() => fields.push({})}>
          Add {buttonName}
        </Button>
      </div>

      {fields.map((fieldName, index) => (
        <div key={fieldName} className="custom-field-wrapper">
          <div className="custom-field-number">
            {`Question ${index + 1}`}
          </div>

          <div className="custom-field-grid">
            <Field
              name={`${fieldName}.heading`}
              component={InputWithLabel}
              placeholder="Enter Question"
              label="Question"
            />
          </div>

          <Field
            name={`${fieldName}.steps`}
            component={TextArea}
            placeholder="Enter each step on a new line"
            label="Steps"
            rows={8}
          />

          <div className="custom-field-delete">
            <Button
              onClick={() => fields.remove(index)}
              appearance="primary"
              className="delete-btn"
            >
              <LegacyTrashIcon />
              <p>Delete</p>
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}